import * as React from 'react'
import { BREAKPOINT_DESKTOP, COLORS } from 'static/constants'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  childrenWithProps: React.ReactElement<any, string | React.JSXElementConstructor<any>>
  expanded: boolean
  toggleExpanded: () => void
  className?: string
  disableMaxWidth?: boolean
}

export const ExpandableBody: React.VFC<IProps> = ({
  childrenWithProps,
  className = '',
  disableMaxWidth = false,
  expanded,
  toggleExpanded,
}) => {
  return (
    <PageMain className={className} $disableMaxWidth={disableMaxWidth} expanded={expanded}>
      <>
        <div className="toggleExpanded" onClick={toggleExpanded}>
          {expanded ? (
            <SvgIcon name="chevron_right" ariaHidden={true} role="presentation" />
          ) : (
            <SvgIcon name="chevron_left" ariaHidden={true} role="presentation" />
          )}
        </div>
        {childrenWithProps}
      </>
    </PageMain>
  )
}

const PageMain = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: ${({ $disableMaxWidth, expanded }: { $disableMaxWidth: boolean; expanded: boolean }) =>
    $disableMaxWidth ? 'none' : expanded ? 'max-content' : '1340px'};
  min-width: 0;
  margin: 0 auto;
  transition: width ease-in-out 0.1s;
  margin-left: ${({ expanded }: { expanded: boolean }) => (expanded ? '40px' : 'auto')};
  padding: ${({ expanded }: { expanded: boolean }) =>
    expanded ? '22px 20px 80px 4px' : '20px 40px 80px 4px'};
  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px;
  }

  .toggleExpanded {
    position: absolute;
    top: 45%;
    left: -21px;
    transform: translateY(-50%);
    border: 1px solid ${COLORS.tertiary};
    border-radius: 4px 0 0 4px;
    padding: 24px 0;
    background: ${COLORS.background};
    color: ${COLORS.primary};
    cursor: pointer;
    @media (max-width: ${BREAKPOINT_DESKTOP}px) {
      display: none;
    }
    box-shadow: ${COLORS.cardShadow};
  }
`
